import useMutationApi from '../../useMutationApi';
import { SupportedGPTModels } from 'src/pages/authenticated/core/spreadsheets/types/spreadsheetTypes';

interface WorkflowExtractConstantsRequest {
  data: string; // cleaned CSV for selected sheet
  instructions: string;
  fileNames: string[];
  sheetName: string;
  model: SupportedGPTModels;
  suppliers?: Array<{ id: string; name: string }>; // optional supplier list for matching
  testMode?: boolean;
}

interface DateRange {
  startDate: string;
  endDate: string;
}

type ExtractedConstantsById = {
  supplierId: string;
  currency: string;
  dateRange?: DateRange;
};

type ExtractedConstantsByName = {
  supplierName: string;
  currency: string;
  dateRange?: DateRange;
};

interface WorkflowExtractConstantsResponse {
  constants: ExtractedConstantsById | ExtractedConstantsByName;
}

const useWorkflowExtractConstants = () => {
  return useMutationApi<
    WorkflowExtractConstantsRequest,
    WorkflowExtractConstantsResponse
  >({
    endpoint: 'spreadsheet/workflow/extract-constants',
    method: 'POST',
    successMessage: 'Extracted constants',
    showSuccessToast: false,
  });
};

export default useWorkflowExtractConstants;
